import React, { FC } from 'react';
import styled from 'styled-components';
import { useTranslation, TranslateFn } from '@blocs.i18n';
import { StyledIcon } from '../../../common/EmptyState/EmptyStateStyles';

export const NoContentText = styled.div`
  font-size: 1.25rem;
  color: ${(props): string => props.theme.colors.primary.grey1};
  font-weight: 600;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
`;

type Props = {
  isExpired?: boolean;
  iconName: string;
  typeName: string;
};

const getTitleForNoContentExpired = (t: TranslateFn, { typeName }) => {
  return typeName === 'presentation'
    ? t(`common:recipientView.noContentExpired.presentationTitle`)
    : t(`common:recipientView.noContentExpired.packageTitle`);
};

const getDescriptionForNoContentExpired = (t: TranslateFn, { typeName }) => {
  return typeName === 'presentation'
    ? t(`common:recipientView.noContentExpired.presentationDescription`)
    : t(`common:recipientView.noContentExpired.packageDescription`);
};

const RecipientViewExpired: FC<Props> = ({ isExpired, iconName, typeName }) => {
  const { t } = useTranslation();

  const expiredNoContentTitle = getTitleForNoContentExpired(t, { typeName });
  const expiredNoContentDescription = getDescriptionForNoContentExpired(t, { typeName });

  return (
    <NoContentText data-testid="no-content-wrapper">
      {isExpired ? (
        <>
          <StyledIcon name={iconName} />
          <div>{expiredNoContentTitle}</div>
          <div>{expiredNoContentDescription}</div>
        </>
      ) : (
        t(`common:recipientView.noContent.${typeName}`)
      )}
    </NoContentText>
  );
};

export default RecipientViewExpired;
